import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {connect} from "react-redux";

function GeneralSubMenu(props) {
    const [menuIDList, setMenuIDList] = useState([])
    const location = useLocation();

    useEffect(() => {
        if (props.permissionData.length > 0) {
            const menu_id_list = [
                ...new Set(props.permissionData.map((item) => item.menu_id)),
            ];
            setMenuIDList(menu_id_list)
        }
    }, [props.permissionData])

    const isActive = (pathname, target) =>
        pathname === target || pathname.startsWith(`${target}/`);

    return (
        <div className="w-full border-b border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-0 transition-colors duration-200" id="kt_header_navs">
            <div className="mx-auto max-w-full px-4 sm:px-6 lg:px-8">
                <div className="flex w-full items-center" id="kt_header_navs_wrapper">
                    {menuIDList.length > 0 &&
                        menuIDList.map((id, i) => {
                            const sub_menu_list = props.permissionData.filter(p => p.menu_id === id);
                            return (
                                <div key={i} className={`w-full ${i === 0 ? 'block' : 'hidden'}`} id={`menu-${id}`} data-menu-id={id}>
                                    <nav className="flex flex-wrap items-center gap-1 py-2 sm:py-3 overflow-x-auto" id="#kt_header_menu">
                                        {sub_menu_list.length > 0 &&
                                            sub_menu_list.map((sub, index) => {
                                                const active = isActive(location.pathname, sub.sub_menu_link);
                                                return (
                                                    <Link
                                                        key={index}
                                                        to={sub.sub_menu_link}
                                                        className={[
                                                            "rounded-lg px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-semibold transition-colors whitespace-nowrap touch-manipulation",
                                                            active
                                                                ? "bg-indigo-600 text-white dark:bg-indigo-500"
                                                                : "text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100",
                                                        ].join(" ")}
                                                    >
                                                        {sub.sub_menu_name}
                                                    </Link>
                                                );
                                            })
                                        }
                                    </nav>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        permissionData: state.PermissionDetails,
    };
};

export default connect(mapStateToProps, null)(GeneralSubMenu);
